import { render } from "./LoginPerusahaan.vue?vue&type=template&id=4964dadc&scoped=true"
import script from "./LoginPerusahaan.vue?vue&type=script&lang=js"
export * from "./LoginPerusahaan.vue?vue&type=script&lang=js"

import "./LoginPerusahaan.vue?vue&type=style&index=0&id=4964dadc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4964dadc"

export default script